module.exports = "https://trybtryb-legacy.web.app/img/lock2.28846d42.svg";